import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import NoInternetComp from "../../components/common/InternetConnetction/NoInternetComp";
import { Breadcrumbs, Typography } from "@mui/material";
import config from "../../config.json";
import moment from "moment";

function BlogDetailPage() {
  const [videoId, setVideoId] = useState(null);
  const { blog } = useLocation().state;
  const baseurl = config.url;

  useEffect(() => {
    window.scrollTo(0, 0);

    const extractedId = extractYouTubeId(blog.youtube_url || "");
    setVideoId(extractedId);
  }, []);

  const extractYouTubeId = (url) => {
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /(?:youtube\.com\/shorts\/)([^&\n?#]+)/,
      /(?:youtube\.com\/v\/)([^&\n?#]+)/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  };

  return (
    <>
      <Container className="pt-2">
        {navigator.onLine ? (
          <Container>
            <Container className="min-h-[65vh]">
              <Container className="max-w-7xl w-full flex flex-col gap-3 mx-auto mb-12 px-3">
                <Breadcrumbs
                  separator=">"
                  aria-label="breadcrumb"
                  sx={{
                    fontFamily: "Poppins",
                  }}
                >
                  <Link underline="hover" color="inherit" to="/insights">
                    Insights
                  </Link>
                  <Typography
                    color="text.primary"
                    sx={{
                      fontFamily: "Poppins",
                    }}
                  >
                    Detail
                  </Typography>
                </Breadcrumbs>

                <img
                  src={baseurl + blog.image}
                  alt="Solmelu"
                  className="rounded-lg md:h-[64dvh] object-cover"
                />
                <p className="text-right mb-1 text-gray-500 text-sm">
                  {blog.createdAt ? moment(blog.createdAt).format("ll") : ""}
                </p>
                <h1 className="font-semibold text-3xl mt-4">{blog.title}</h1>
                <hr className="w-[5%] border-black border-2 mb-4" />
                <Container className="text-left">
                  <div
                    className="prose prose-gray max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: blog.description,
                    }}
                  />
                </Container>

                {videoId && (
                  <Container>
                    <div className="aspect-w-16 aspect-h-9">
                      <iframe
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-full min-h-[250px] sm:min-h-[350px] lg:min-h-[500px] rounded-lg"
                      />
                    </div>
                  </Container>
                )}
              </Container>
            </Container>
          </Container>
        ) : (
          <Container className="min-h-[65vh] flex flex-col justify-center items-center">
            <NoInternetComp />
          </Container>
        )}
      </Container>
    </>
  );
}

export default BlogDetailPage;
